import { render } from "./FoliosEnrollmentContent.vue?vue&type=template&id=4c8e628f&ts=true"
import script from "./FoliosEnrollmentContent.vue?vue&type=script&lang=ts"
export * from "./FoliosEnrollmentContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__